// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__29Lhh","content":"Footer_content__3PheW","left":"Footer_left__31XDK","right":"Footer_right__1My-N","app":"Footer_app__iRzwH"};